import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from '@contentful/live-preview/react';
import type {
  Entity,
  InspectorModeTags,
  LivePreviewProps,
} from '@contentful/live-preview/dist/types';

type GetInspectorModeProps<T> = (props: {
  [K in Exclude<
    keyof LivePreviewProps,
    keyof T | 'locale'
  >]: LivePreviewProps[K];
}) => InspectorModeTags;

export type InspectorModeHTMLTags = {
  'data-contentful-entry-id'?: string;
  'data-contentful-field-id'?: string;
  'data-contentful-locale'?: string;
};

export type InspectorPropsType = GetInspectorModeProps<
  Pick<LivePreviewProps, 'entryId'>
>;

type ReturnType<T extends Entity> = {
  updatedEntity: T;
  inspectorProps: GetInspectorModeProps<Pick<LivePreviewProps, 'entryId'>>;
};

export const useLivePreview = <T extends Entity>(props: T): ReturnType<T> => {
  const updatedEntity = useContentfulLiveUpdates(props);
  const inspectorProps = useContentfulInspectorMode({
    entryId: props?.sys?.id as string,
  });

  return {
    updatedEntity,
    inspectorProps,
  };
};
